import React from 'react';

export enum RNPAction {
  delete = 'delete',
}

export interface OnDeleteArgs {
  roleId: string;
  roleName: string;
}

type RNPActionContextType = {
  actionsToRender: RNPAction[];
  onDelete: (role: OnDeleteArgs) => void;
  onEdit: (roleId: string) => void;
};

export const defaultRnpActionsValue: RNPActionContextType = {
  actionsToRender: [],
  onDelete: () => {},
  onEdit: () => {},
};

export const RNPActionsContext = React.createContext<RNPActionContextType>({
  ...defaultRnpActionsValue,
});

export const useRNPActionsContext = () => React.useContext(RNPActionsContext);
